module["exports"] = [
  "შპს",
  "სს",
  "ააიპ",
  "სსიპ"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ge/company/prefix.js
 ** module id = 631
 ** module chunks = 0
 **/